import { queryOptions, useQuery } from '@tanstack/react-query';

import { useAuthentication } from '../../Idp/useAuthentication';
import { coreApi, useCoreApi } from '../api';
import { coreKeys } from '../query-key-factory';
import { ICredential } from './paymentMethods.types';

const getPaymentMethods = async () => {
  const { data } = await coreApi.get<{ credentials: ICredential[] }>(`/v2/payment_methods`);
  return data.credentials;
};

const useListPaymentMethodsQuery = () => {
  const { isAuthenticated } = useAuthentication();

  return queryOptions({
    queryKey: coreKeys.user.paymentMethods.all,
    queryFn: getPaymentMethods,
    enabled: isAuthenticated,
    placeholderData: [],
  });
};

const useListPaymentMethods = <T = ICredential[]>(select?: (data: ICredential[]) => T) => {
  return useQuery({
    ...useListPaymentMethodsQuery(),
    select,
  });
};

export function useShowPaymentMethodV2({ uuid }: { uuid: string }) {
  const { isAuthenticated } = useAuthentication();
  const CoreApi = useCoreApi();

  const get = async () => {
    const { data } = await CoreApi.get<{ credential: ICredential }>(`/v2/payment_methods/${uuid}`);
    return data.credential;
  };

  return useQuery({
    queryKey: coreKeys.user.paymentMethods.id(uuid).all,
    queryFn: get,
    enabled: isAuthenticated,
  });
}

export { useListPaymentMethods, useListPaymentMethodsQuery };
